"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanizeAsSentence = void 0;
const change_case_1 = require("change-case");
const camelEdges = /([A-Z](?=[A-Z][a-z])|[^A-Z](?=[A-Z])|[a-zA-Z](?=[^a-zA-Z]))/g;
const isCamelCase = (str) => {
    return /^[A-Za-z0-9]+$/.test(str);
};
/**
 * Convert text in camel case (and others) to title case,
 * preserving abbreviations.
 *
 * @param {string} text
 * @returns string
 */
const humanizeString = (text) => {
    if (typeof text !== "string") {
        return text;
    }
    if (isCamelCase(text)) {
        // Special handling for camel cases to preserve abbreviations
        // Based on https://stackoverflow.com/a/34680912/277871
        const replaced = text.replace(camelEdges, "$1 ");
        const formatted = replaced.charAt(0).toUpperCase() + replaced.slice(1);
        return formatted.replace(/^Hub Spot\./, "HubSpot.");
    }
    // If the string is dot
    if (text.includes(".")) {
        return text
            .split(".")
            .map((word) => (0, change_case_1.capitalCase)(word))
            .join(".");
    }
    return (0, change_case_1.capitalCase)(text);
};
const humanizeAsSentence = (text) => {
    return (0, change_case_1.sentenceCase)(humanizeString(text));
};
exports.humanizeAsSentence = humanizeAsSentence;
exports.default = humanizeString;
//# sourceMappingURL=humanizeString.js.map